function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "#000",
  strokeOpacity: 0.4,
  d: "m35.818 12.005-.024-.026a16.774 16.774 0 0 0-23.854 0c-6.587 6.64-6.587 17.403 0 24.042a16.774 16.774 0 0 0 23.853 0l8.99-9.061a4.21 4.21 0 0 0 .001-5.918z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-map-pin-head-pointer.svg";
export { SvgComponent as ReactComponent };